var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }

  return cooked;
};

import React from 'react';
import styled, { css } from 'styled-components';
import { classNames } from '../../utils/cn';
var cls = classNames('menu');
import { breakpoints, theme } from '@shapeable/theme';
import { usePage } from '../../hooks/use-page';
import { useMenu } from '../../hooks/use-menu';
import { DownloadLink } from './download-link';
import { useMenuItems } from '../../hooks/use-menu-items';
import { MenuLink } from './menu-link';
import { MenuSectionLink } from './menu-section-link';
import { LinearNavigation } from './linear-navigation';
import { createSlot, useSlots } from '../../utils/slot';
import { CopyrightPrivacyLabel } from './copyright-privacy-label';
export var MenuDefaultProps = {}; // -------- Child Component Props -------->
// -------- Styles -------->

var ContainerStyles = breakpoints({
  base: css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    box-sizing: border-box;\n    padding: ", " ", " ", ";\n    background: ", ";\n  "], ["\n    box-sizing: border-box;\n    padding: ", " ", " ", ";\n    background: ", ";\n  "])), theme.UNIT(2), theme.UNIT(3), theme.UNIT(4), theme.COLOR('light')),
  tablet: css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    padding: ", " ", " ", ";\n  "], ["\n    padding: ", " ", " ", ";\n  "])), theme.UNIT(2), theme.UNIT(4), theme.UNIT(4))
});
var SectionLinkStyles = breakpoints({
  base: css(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    \n  "], ["\n    \n  "])))
});
var SectionStyles = breakpoints({
  base: css(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n    margin: 0;\n    padding: ", " 0;\n    border-top: 1px solid ", ";\n  "], ["\n    margin: 0;\n    padding: ", " 0;\n    border-top: 1px solid ", ";\n  "])), theme.UNIT(4), theme.COLOR('line-subtle'))
});
var ItemsStyles = breakpoints({
  base: css(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n    list-style: none;\n    margin: 0;\n    padding: 0;\n  "], ["\n    list-style: none;\n    margin: 0;\n    padding: 0;\n  "])))
});
var PageStyles = breakpoints({
  base: css(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n    margin: 0;\n    padding: 0 0 ", ";\n  "], ["\n    margin: 0;\n    padding: 0 0 ", ";\n  "])), theme.UNIT(3))
});
var PageLinkStyles = breakpoints({
  base: css(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n    \n  "], ["\n    \n  "])))
});
var FooterStyles = breakpoints({
  base: css(templateObject_8 || (templateObject_8 = __makeTemplateObject(["\n    padding: ", " 0;\n    border-top: 1px solid ", ";\n    a {\n      color: ", ";\n      text-decoration: none;\n    }\n  "], ["\n    padding: ", " 0;\n    border-top: 1px solid ", ";\n    a {\n      color: ", ";\n      text-decoration: none;\n    }\n  "])), theme.UNIT(2), theme.COLOR('line-subtle'), theme.COLOR('primary'))
});
var DownloadLinkStyles = breakpoints({
  base: css(templateObject_9 || (templateObject_9 = __makeTemplateObject(["\n    margin-top: ", ";\n    margin-bottom: ", ";\n    font-size: 0.9em;\n  "], ["\n    margin-top: ", ";\n    margin-bottom: ", ";\n    font-size: 0.9em;\n  "])), theme.UNIT(2), theme.UNIT(3))
});
var LinearNavigationStyles = breakpoints({
  base: css(templateObject_10 || (templateObject_10 = __makeTemplateObject(["\n    margin-top: ", ";\n    margin-bottom: ", ";\n    margin-left: -2px;\n    margin-right: -2px;\n  "], ["\n    margin-top: ", ";\n    margin-bottom: ", ";\n    margin-left: -2px;\n    margin-right: -2px;\n  "])), theme.UNIT(1), theme.UNIT(3)),
  tablet: css(templateObject_11 || (templateObject_11 = __makeTemplateObject(["\n    display: none;\n  "], ["\n    display: none;\n  "])))
});
var CopyrightPrivacyStyles = breakpoints({
  base: css(templateObject_12 || (templateObject_12 = __makeTemplateObject(["\n    \n  "], ["\n    \n  "])))
}); // -------- Components -------->

var My = {
  Container: styled.div(templateObject_13 || (templateObject_13 = __makeTemplateObject(["", ""], ["", ""])), ContainerStyles),
  LinearNavigation: styled(LinearNavigation)(templateObject_14 || (templateObject_14 = __makeTemplateObject(["", ""], ["", ""])), LinearNavigationStyles),
  DownloadLink: styled(DownloadLink)(templateObject_15 || (templateObject_15 = __makeTemplateObject(["", ""], ["", ""])), DownloadLinkStyles),
  Items: styled.ul.attrs(cls.attr('items'))(templateObject_16 || (templateObject_16 = __makeTemplateObject(["", ""], ["", ""])), ItemsStyles),
  Section: styled.li.attrs(cls.attr('section'))(templateObject_17 || (templateObject_17 = __makeTemplateObject(["", ""], ["", ""])), SectionStyles),
  SectionLink: styled(MenuSectionLink)(templateObject_18 || (templateObject_18 = __makeTemplateObject(["", ""], ["", ""])), SectionLinkStyles),
  Page: styled.li.attrs(cls.attr('page'))(templateObject_19 || (templateObject_19 = __makeTemplateObject(["", ""], ["", ""])), PageStyles),
  PageLink: styled(MenuLink)(templateObject_20 || (templateObject_20 = __makeTemplateObject(["", ""], ["", ""])), PageLinkStyles),
  Footer: styled.div.attrs(cls.attr('footer'))(templateObject_21 || (templateObject_21 = __makeTemplateObject(["", ""], ["", ""])), FooterStyles),
  CopyrightPrivacy: styled(CopyrightPrivacyLabel)(templateObject_22 || (templateObject_22 = __makeTemplateObject(["", ""], ["", ""])), CopyrightPrivacyStyles)
};
var slots = {
  Head: createSlot(),
  Foot: createSlot()
};
export var Menu = function Menu(props) {
  var className = props.className,
      privacyPath = props.privacyPath,
      children = props.children,
      afterNav = props.afterNav,
      beforeNav = props.beforeNav,
      copyrightPrivacy = props.copyrightPrivacy;
  var menuItems = useMenuItems();
  var menu = useMenu();
  var page = usePage();
  var ref = menu.useClickOutside();
  var Slots = useSlots(slots);
  var head = props.head !== undefined ? props.head : React.createElement(Slots.Head, null);
  var foot = props.foot !== undefined ? props.foot : React.createElement(Slots.Foot, null);
  return React.createElement(My.Container, {
    ref: ref,
    className: cls.name(className)
  }, beforeNav, React.createElement(My.LinearNavigation, {
    borderless: true,
    showButtons: false,
    value: page && page.path
  }), afterNav, React.createElement(My.DownloadLink, null), head, React.createElement(My.Items, null, menuItems.map(function (item) {
    return item.type == 'Section' ? React.createElement(My.Section, {
      key: item.path
    }, React.createElement(My.SectionLink, {
      section: item
    })) : React.createElement(My.Page, {
      key: item.path
    }, React.createElement(My.PageLink, {
      item: item
    }));
  })), React.createElement(My.Footer, null, foot, copyrightPrivacy || React.createElement(My.CopyrightPrivacy, {
    privacyPath: privacyPath
  }), children));
};
Menu.defaultProps = MenuDefaultProps;
Menu.cls = cls;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9, templateObject_10, templateObject_11, templateObject_12, templateObject_13, templateObject_14, templateObject_15, templateObject_16, templateObject_17, templateObject_18, templateObject_19, templateObject_20, templateObject_21, templateObject_22;